
(function () {
    'use strict';

    angular.module("handbookApp")
           .controller('SendDocumentToHearingEmailController', controller);

    controller.$inject = ['$uibModalInstance', 'objectEmailContent'];

    function controller($modalInstance, objectEmailContent) {
        var vm = this;

        vm.translation = globalResources;
        vm.email = {
            subject: '',
            body: ''
        };

        vm.saveChanges = saveChanges;
        vm.cancel = cancel;

        initialize();

        function initialize() {
            vm.email.subject = vm.translation.SubjectSendToHearingCreate;
            var extraInfo = objectEmailContent.allowForwarding ? vm.translation.ExtraInfoSendToHearingCreate : '';
            vm.email.body = String.format(vm.translation.BodySendToHearingCreate, objectEmailContent.documentName, objectEmailContent.dueDate, objectEmailContent.url, objectEmailContent.documentResponsible, extraInfo);
        };

        function saveChanges() {
            if (vm.email.subject && vm.email.body) {
                $modalInstance.close(vm.email);
            }
        }

        function cancel() {
            $modalInstance.dismiss('cancel');
        }
    };
})();